
export const adminBaseUrl = 'https://new.fotama.com/api'
// export const adminBaseUrl = 'http://localhost:8000/api'

// export const adminBaseUrl = 'https://fotama-backend.vercel.app/api'